import { maybeFormatRegisteredObject } from './log_format.ts';

function inspectSingleObject(element: any): string {
  if (element) {
    if (typeof element === 'object') {
      if (element.__inspect && typeof element.__inspect === 'function') {
        return element.__inspect();
      }

      if (Array.isArray(element)) {
        return `[${element.length}]`;
      }

      const ctor = Object.getPrototypeOf(element).constructor;

      if (ctor === Set) {
        return `Set(${element.size})`;
      }

      if (ctor === Map) {
        return `Map(${element.size})`;
      }

      if (ctor === WeakSet) {
        return `WeakSet(${element.size})`;
      }

      if (ctor === WeakMap) {
        return `WeakMap(${element.size})`;
      }

      if (ctor === Object) {
        return '{…}';
      }

      return Object.getPrototypeOf(element).constructor.name;
    }

    if (typeof element === 'function') {
      return `<Function>`;
    }
  }

  return JSON.stringify(element);
}

// https://github.com/microsoft/vscode/issues/102181#issuecomment-1147571945
export function __registerGlobalInspect() {
  if (globalThis.__inspectObject) {
    return;
  }

  // return;

  globalThis.__inspectObject = function (target: any, def: string) {
    // return 'foo';
    // if (target.__inspect && typeof target.__inspect === 'function') {
    //   return '__inspect()';
    //   return target.__inspect();
    // }

    const maxPropertyCount = 5;
    const elements = [];
    if (Array.isArray(target)) {
      return 'array';
      for (let i = 0; i < Math.min(maxPropertyCount, target.length); ++i) {
        elements.push(inspectSingleObject(target[i]));
      }
      return `(${target.length}) [${elements.join(', ')}${
        target.length > maxPropertyCount ? '…' : ''
      }]`;
    }

    return maybeFormatRegisteredObject(target) ?? def;

    for (let key in target) {
      if (target.hasOwnProperty(key)) {
        if (elements.length >= maxPropertyCount) {
          break;
        }

        elements.push(`${key}: ${inspectSingleObject(target[key])}`);
      }
    }

    return `{${elements.join(', ')}}`;
  };
}
